import { isDev } from "./IsDev";

export const DevLog = (message?: any, ...optionalParams: any[]) => {
  if (isDev) {
    return console.log(message, ...optionalParams);
  }
}